import { api } from '@/store/interface/apiCraft'
import Vue from 'vue'

import global from "@/assets/data/global.json"
import districts from "@/assets/data/districts.json"
import auditorium from "@/assets/data/auditorium.json"

export default {
  namespaced: true,

  state: {
    districts: [...districts],
    auditorium: {...auditorium},
    global: {...global},
    isLoaded: false,
    searchedPosts: [],
    fullFavorites: [],
    tutorials: []
  },

  getters: {
    global: state =>{
      return state.global
    },
    urlTown: state =>{
      return state.global.town
    },
    districts: state =>{
      return state.districts
    },
    auditorium: state =>{
      return state.auditorium
    },
    isLoaded: state =>{
      return state.isLoaded
    },
    districtByIndex: state => index => {
      return state.districts[index]
    },
    districtBySlug: state => slug => {
      return state.districts.find(district => { return district.slug === slug })
    },
    districtIndexBySlug: state => slug => {
      return state.districts.findIndex(district => { return district.slug === slug })
    },
    getNextDistrict: (state, getters) => slug => {
      const index = getters.districtIndexBySlug(slug)
      return (index + 1) % state.districts.length
    },
    getNextDistrictIndex: (state, getters) => index => {
      return (index + 1) % state.districts.length
    },
    getPrevDistrict: (state, getters) => slug => {
      const index = getters.districtIndexBySlug(slug)
      return index === 0 ? state.districts.length : index - 1
    },
    getPrevDistrictIndex: (state, getters) => index => {
      return index === 0 ? state.districts.length : index - 1
    },
    searchedPosts (state) {
      return state.searchedPosts
    },
    getEntityFav: (state, getters, rootState) => id => {
      if (!Array.isArray(rootState.user.user.favorites) || !rootState.user.user.favorites.length) {
        return undefined
      }

      // console.log('rootState.user.user.favorites', rootState.user.user.favorites, id, rootState.user.user.favorites[0].craft_id === id)

      return rootState.user.user.favorites.find(fav => fav.craft_id === id)
    },
    isEntityFav: (state, getters) => id => {
      return getters.getEntityFav(id) ? true : false
    },
    favorites (state) {
      return state.fullFavorites
    },
    tutorials: (state) => {
      return state.tutorials
    }
  },

  actions: {
    async global({ commit, state }) {
      const { request, cache } = api.getGlobal()
      cache.then(res => {
        if (res !== null) {
          commit('global', res)
          commit('loaded', true)
        }
      })

      request.then(res => {
        commit('global', res)
        commit('loaded', true)
      })
    },
    // search: args.search, subjects: args.subjects, districtSlug: 'district-3', types: ["sbsArticle"],
    async search({ commit, state, getters }, args) {
      // remove empty array to prevent request failing in craft prod mode
      if (args.types && !args.types.length) { delete args.types }
      if (args.subjects && !args.subjects.length) { delete args.subjects }

      const posts = await api.searchEntries(args)

      commit('clearSearchedPosts')

      if (!posts.length) {
        return
      }

      const district = getters['districtBySlug'](args.districtSlug)

      if (!district) {
        return
      }

      const results = []

      posts.forEach(post => {
        district.sbsKeypoints.forEach(keypoint => {
          results.push( ...keypoint.entries.filter(entry => entry.slug === post.slug) )
        })
      })

      commit('searchedPosts', results)
    },

    async computeFav({ commit, state, rootState }) {
      const favIds = rootState.user.user.favorites.map(fav => fav.craft_id)

      const { request, cache } = api.getFavorites(favIds)
      cache.then(res => {
        if (res !== null) {
          commit('fullFavorites', res)
        }
      })

      request.then(res => {
        commit('fullFavorites', res)
      })
    }
  },

  mutations: {
    loaded (state, payload) {
      state.isLoaded = payload
    },
    global (state, payload) {
      for (let i = 0; i < payload.sbsDistricts.length; i++) {
        let subjects = []
        payload.sbsDistricts[i].sbsKeypoints.forEach(keypoint => {
          keypoint.position = {
            x: keypoint.positionX,
            y: keypoint.positionY,
            z: keypoint.positionZ
          }
          delete keypoint.positionX
          delete keypoint.positionY
          delete keypoint.positionZ

          keypoint.entries.forEach(entry => {
            entry.url = `/district/${payload.sbsDistricts[i].slug}/${keypoint.slugg}/${entry.slug}`
          })

          // get all keypoint subject / tags
          subjects.push(...keypoint.entries.reduce((reducer, article) => {
            if (article.sbsSubject.length) {
              reducer.push(...article.sbsSubject)
            }
            return reducer
          }, []))

        })

        // remove duplicate keypoint subject / tags
        payload.sbsDistricts[i].sbsSubjects = subjects.filter((item, pos) => {
          return subjects.findIndex(subject => { return subject.id === item.id }) === pos
        })

        state.tutorials = payload.sbsTutorials.filter(tuto => tuto.text !== '')
        Vue.set(state.districts, i, {...state.districts[i], ...payload.sbsDistricts[i]})
      }
    },
    districtCamera (state, {index, cameraPos, look, cameraPosDistrict, lookDistrict}) {
      Vue.set(state.districts[index], 'cameraPos', cameraPos)
      Vue.set(state.districts[index], 'look', look)
      Vue.set(state.districts[index], 'cameraPosDistrict', cameraPosDistrict)
      Vue.set(state.districts[index], 'lookDistrict', lookDistrict)
    },
    auditoriumCamera (state, {index, cameraPos, look}) {
      Vue.set(state.auditorium, 'cameraPos', cameraPos)
      Vue.set(state.auditorium, 'look', look)
    },
    searchedPosts (state, posts) {
      state.searchedPosts = posts
    },
    clearSearchedPosts (state) {
      state.searchedPosts.splice(0, state.searchedPosts.length)
    },
    fullFavorites (state, payload) {
      state.fullFavorites = payload
    }
  }
}